<template>
  <component :is="layoutComponent" v-bind="layoutProps" class="color-picker-form">
    <template slot="field">
      <input id="details.schedule_color" v-model="fieldValue" disabled type="text" class="form-control" />
      <v-input-colorpicker v-model="fieldValue" />
    </template>
  </component>
</template>

<script>
import { FormField } from "stylemix-base";
import InputColorPicker from 'vue-native-color-picker';

export default {
  name: "FormColorField",
  components: {
    "v-input-colorpicker": InputColorPicker,
  },
  extends: FormField,
  data() {
    return {};
  },
  mounted() {
    if (this.field.default && !this.fieldValue)
      this.fieldValue = this.field.default ?? '#4caf50';

    this.$on("changeColors", this.changeColors);
  },
  methods: {
    changeColors(val) {
      if (val[this.field.attribute]) {
        this.fieldValue = val[this.field.attribute];
      }
    },
  },
};
</script>
<style>
.color-picker-form > div {
  display: flex;
}
.color-picker-form > div .icp__input {
  display: block;
  width: 20% !important;
  height: 2.1875rem !important;
  padding: 0.375rem 0.75rem !important;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
  background-color: #fff;
  border: 1px solid #ddd !important;
  border-radius: 0.1875rem !important;
  -webkit-box-shadow: 0 0 0 0 transparent;
  box-shadow: 0 0 0 0 transparent;
  background-clip: border-box;
  margin-left: 10px;
}
</style>
